import { FC, useState } from 'react';
import ManageVideosLink from './ManageVideosLink';
import { parseVideoLink } from '../../../../common/videoUtils';
import { t } from 'i18next';
import VideoModal from './VideoModal';

interface IAddVideoProps {
  rosters: any[];
  forceRefresh: () => void;
  type: string;
  className?: string;
  onSubmit: (params: any) => void;
}

const EntityAddVideo: FC<IAddVideoProps> = ({ forceRefresh, rosters, onSubmit, type, className }) => {
  const [open, setOpen] = useState(false);

  const validatePrefilledVideo = (url: string, withTimestamp: boolean) => {
    const parsedUrl = parseVideoLink(url, withTimestamp);
    if (!parsedUrl) {
      return t('videos:errors.url-parse-error');
    }
    return null;
  };

  return (
    <div className={className}>
      <VideoModal
        validate={validatePrefilledVideo}
        type={type}
        onSubmit={onSubmit}
        rosters={rosters}
        forceRefresh={forceRefresh}
        isOpen={open}
        onClose={() => setOpen(false)}
      />
      <ManageVideosLink
        onClick={(e: any) => {
          e.preventDefault();
          setOpen(true);
        }}
      />
    </div>
  );
};

export default EntityAddVideo;
